// importing essentials
import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import FormFooter from "../../general/FormFooter";

const UpdateUser = ({ check, userInfo, loading }) => {
    const history = useHistory();
    const permissions = userInfo.permissions;

    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [role, setRole] = useState('');
    const [roles, setRoles] = useState([]);
    const [allLoading, setAllLoading] = useState(true)
    const [selectedFile, setSelectedFile] = useState('');

    const { id } = useParams();


    const changeFileHandler = (event) => {
        setSelectedFile(event.target.files[0]);
    };
    const fetchRoles = async () => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_BACKLINK}/api/private/show-roles`,
                { withCredentials: true }
            );
            setRoles(data.roles)
            const { data: packet } = await axios.get(
                `${process.env.REACT_APP_BACKLINK}/api/private/get-user/${id}`,
                { withCredentials: true }
            );
            setAllLoading(false)
            setUsername(packet.user.username)
            setEmail(packet.user.email)
            setRole(packet.user.role)
            setSelectedFile(packet.user.profileImage)
        } catch (error) {
            setError(error.message)
        }
    };


    useEffect(() => {
        fetchRoles()
    }, []);
    const AddUser = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("username", username);
        formData.append("email", email);
        formData.append("role", role);
        formData.append("profileImage", selectedFile);

        try {
            await axios.put(
                `${process.env.REACT_APP_BACKLINK}/api/private/update-user/${id}`,
                formData,
                { withCredentials: true }
            );
            history.push('/show-users');
        }
        catch (err) {
            setError(err.response.msg)
        }
    };

    return (
        <>
            {loading ? <h1 style={{ color: 'white' }}>Loading...</h1> :
                allLoading ? <h1 style={{ color: 'white' }}>AllLoading...</h1> :

                    Object.keys(userInfo).length > 0 && !(Number(userInfo.id) === Number(id)) && !check ? <h1>You are not authorized, Contact with your admin.</h1> :
                        <form onSubmit={AddUser} encType='multipart/form-data' className="row">
                            {error && <span className="bg-danger">{error}</span>}

                            <div className="form-group col-sm-6">
                                <label>Username:</label>
                                <input type="text" className="form-control"
                                    name="username"
                                    value={username}
                                    placeholder="Username"
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                            <div className="form-group col-sm-6">
                                <label>Email:</label>
                                <input type="email" name="email" className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>

                            {permissions.includes('/update-role/:id') && <div className="col-sm-6">
                                <label htmlFor="">Choose Role: </label>
                                <select className="form-control form-select"
                                    name="role"
                                    value={role}
                                    // defaultValue='select'
                                    onChange={e => setRole(e.target.value)} >
                                    <option value='select' disabled>Select Role</option>
                                    {roles.map(item => (
                                        <option key={item.rolename} name={item.rolename} value={item.rolename}>{item.rolename}</option>
                                    ))}
                                </select>
                            </div>}
                            <div className="mb-3 col-sm-6">
                                <label htmlFor="formFile" className="form-label">Choose Image: </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    filename="profileImage"
                                    id="formFile"
                                    onChange={changeFileHandler} />
                            </div>
                            <FormFooter button="Update User" />
                        </form>
            }
        </>
    );
};

export default UpdateUser;